import { render, staticRenderFns } from "./KeyboardShortcutsHelp.vue?vue&type=template&id=60fe8f0c&scoped=true"
import script from "./KeyboardShortcutsHelp.vue?vue&type=script&lang=js"
export * from "./KeyboardShortcutsHelp.vue?vue&type=script&lang=js"
import style0 from "./KeyboardShortcutsHelp.vue?vue&type=style&index=0&id=60fe8f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe8f0c",
  null
  
)

export default component.exports